import Vue from 'vue'
import Vuex from 'vuex'
import Toasted from 'vue-toasted'
import jwtDecode from 'jwt-decode'
import VideoService from '@/services/VideoService.js'
import SpeakerBiosService from '@/services/SpeakerBiosService.js'
import UserService from '@/services/UserService.js'
import VuexPersistence from 'vuex-persist'
const vuexLocal = new VuexPersistence({
  storage: window.localStorage
})
Vue.use(Vuex)
Vue.use(Toasted)

export default new Vuex.Store({
  state: {
    videos: [],
    speakers: [],
    user: { isLoggedIn: false }
  },
  mutations: {
    SET_VIDEOS(state, videos) {
      state.videos = videos
    },
    SET_SPEAKER(state, speakers) {
      state.speakers = speakers
    },
    SET_USERS(state, user) {
      state.user = user
    }
  },
  actions: {
    async login({ commit }, [email, password]) {
      try {
        const data = await UserService.login(email, password)
        let user = { isLoggedIn: false }
        if (data.jwt) {
          const userInfo = jwtDecode(data.jwt)
          user = {
            isLoggedIn: true,
            email: userInfo.email,
            firstName: userInfo.firstname,
            lastName: userInfo.lastname,
            jwt: data.jwt,
            role: userInfo.role
          }
          Vue.toasted.show('Hello there, you are logged in!').goAway(2500)
        } else {
          Vue.toasted.show('Password invalid or expired!').goAway(2500)
        }
        commit('SET_USERS', user)
      } catch (error) {
        Vue.toasted.show('Password invalid or expired').goAway(2500)
        console.error(error)
        throw error
      }
    },
    logout({ commit }) {
      commit('SET_USERS', { isLoggedIn: false })
    },
    async fetchVideos({ commit, dispatch }) {
      try {
        dispatch('showLoader')
        const data = await VideoService.getVideos()
        commit('SET_VIDEOS', data)
        dispatch('hideLoader')
      } catch (error) {
        console.error(error)
        throw error
      }
    },
    async getChurchProfile() {
      try {
        return await UserService.getChurchProfile()
      } catch (error) {
        console.error(error)
        throw error
      }
    },
    async fetchSpeakers({ commit, dispatch }) {
      try {
        dispatch('showLoader')
        const data = await SpeakerBiosService.getSpeakers()
        commit('SET_SPEAKER', data)
        dispatch('hideLoader')
      } catch (error) {
        console.error(error)
        throw error
      }
    },
    hideLoader() {
      setTimeout(() => {
        if (!$('#load').hasClass('loader-removed')) {
          $('#load').addClass('loader-removed')
        }
      }, 500)
    },
    showLoader() {
      setTimeout(() => {
        if ($('#load').hasClass('loader-removed')) {
          $('#load').removeClass('loader-removed')
        }
      }, 500)
    }
  },
  modules: {},
  plugins: [vuexLocal.plugin]
})
